import { combineEpics } from 'redux-observable';
import { epic as authEpics } from './modules/auth';
import { epic as dataEpics } from './modules/data';

export const rootEpic = combineEpics(...authEpics, ...dataEpics);
